import io from '../socket-client';

export const INIT = 'INIT';
export const USER_LOGIN = 'USER_LOGIN';
export const RESET_LOGIN = 'RESET_LOGIN';
export const REGISTER_USER = 'REGISTER_USER';

export let SERVER_URI; // eslint-disable-line

if (process.env.NODE_ENV === 'production') {
  SERVER_URI = 'https://adspromote.ru';
} else {
  SERVER_URI = 'http://localhost:9004';
}

export function init() {
  io.connect(SERVER_URI);
  const code = getParameterByName('code');
  if (code) {
    return registerUser(code);
  }
  const login = window.localStorage.getItem('login');
  const password = window.localStorage.getItem('password');
  const token = window.localStorage.getItem('access_token');
  if (!login || login === 'undefined' || !token) {
    // Показываем форму авторизации вместо редиректа
    return {
      type: INIT,
      login: '',
      password: '',
      token: null,
    };
  }
  return {
    type: INIT,
    login: login && login,
    password: password && password,
    token,
  };
}

export function userLogin(newLogin, newPassword) {
  return (dispatch, getState) => {
    if (getState().auth.userInfo.token !== undefined) {
      const { login, password, token } = getState().auth.userInfo;
      if (login === newLogin && password === newPassword && token) {
        io.setHeader('authorization', token);
        return dispatch({ type: USER_LOGIN, login, password, token });
      }
    }
    return fetch('/api/oauth/token',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          grant_type: 'password',
          client_id: 'web-client',
          client_secret: 'skd934kd04md',
          username: newLogin,
          password: newPassword,
        }),
      })
      .then(res => {
        res.json().then(
          data => {
            io.setHeader('authorization', data.access_token);
            if (data.access_token) {
              window.localStorage.setItem('login', newLogin);
              window.localStorage.setItem('password', newPassword);
              window.localStorage.setItem('access_token', data.access_token);
            }
            dispatch({
              type: USER_LOGIN,
              login: newLogin,
              password: newPassword,
              token: data.access_token,
            });
          },
        );
      })
      .catch(() => {
        dispatch({ type: USER_LOGIN, token: null });
      });
  };
}

export function registerUser(activationCode) {
  return dispatch => {
    fetch('/api/oauth/register',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: activationCode,
        }),
      })
      .then(res => {
        if (!res.ok) {
          // throw new Error('Regiter error');
          console.log(res.statusText);
          return;
        }
        res.json().then(
          data => {
            const login = window.localStorage.getItem('login');
            if (!data.login || data.login === 'undefined') {
              window.location.replace('http://zakleim.spb.ru/');
            }
            if (data.password) {
              console.log(data.password); // eslint-disable-line
              window.localStorage.setItem('password', data.password);
              window.localStorage.setItem('login', data.login);
            } else if (!login || login === 'undefined') {
              window.location.replace('http://zakleim.spb.ru/');
            }
            console.log(login); // eslint-disable-line
            window.localStorage.removeItem('access_token');
            const { protocol, host } = window.location;
            window.location.replace(`${protocol}//${host}`);
          },
        );
      })
      .catch(() => {
        // window.location.replace('http://zakleim.spb.ru/');
        // dispatch({ type: REGISTER_USER });
      });
  };
}

export function resetLogin() {
  return (dispatch, getState) => {
    if (getState().auth.userStatus === 'USER_FORBIDDEN') {
      dispatch({ type: RESET_LOGIN });
    }
  };
}

function getParameterByName(nameParam, urlParam) {
  const url = urlParam || window.location.href;
  const name = nameParam.replace(/[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



// WEBPACK FOOTER //
// ./src/actions/auth.js